module.exports = __webpack_public_path__ + "img/bold.24e86c54.svg";